import {appendToUrl} from '../util/common';
import {newModalFromString, newModalWithOptions} from '../components/modal';
import productSlider from '../components/productSlider';
import {addToCartFromListing} from '../product/quickView';
import QuickUpdate from '../product/quickUpdate';
import {initSlotCarousel} from '../productTileComponent/productTile';
import { bonusProductModalListener } from '../cart/bonusProductModal';

var timer;
var addedAnother = false;

// necessary to retrieve minicart open status elswehere
const isMiniCartOpen = () => {
    return localStorage.getItem('isMiniCartOpen') === 'true';
};

const setMiniCartOpen = (value) => {
    return localStorage.setItem('isMiniCartOpen', value);
};

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
const createErrorNotification = (message) => {
    var errorHtml =
        '<div class="cart-alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' +
        message +
        '</div>';

    $('.cart-error').append(errorHtml);
};

function hideMiniCart (_self, fromWishlist = false) {
    if (isMiniCartOpen()) {
        _self.miniCartModal.close();
        setMiniCartOpen(false);

        if (!fromWishlist) {
            $('.js-add-to-cart').removeAttr('disabled');
        }
    }
}

function forceShowMinicart (_self, needsUpdate = true, pid, promoId = false, wait = false) {
    if (locationIsCart()) {
        return;
    }
    if (isMiniCartOpen() && !needsUpdate) {
        return;
    }

    var personalizationImageSrcMiniCart = $('.form-color-selected-circle-src').val();
    var formSymbolType = $('.form-symbolType').val();
    var symbol = $('.form-symbol').val();

    var url =
        $('.js-mainHeader-minicart').data('action-url') +
        '?pid=' +
        encodeURIComponent(pid) +
        '&srcImgColor=' +
        personalizationImageSrcMiniCart +
        '&symbol=' +
        symbol +
        '&formSymbolType=' +
        formSymbolType;

    if (promoId) {
        url += '&promotionId=' + encodeURIComponent(promoId);
    }
    let spinStopped = false;
    setTimeout(() => {
        if (!spinStopped) $.spinner().start();
    }, 1000);

    let callback = (data) => {
        var modalContent = data;
        if (data.trim() === '') {
            return;
        }

        if (isMiniCartOpen()) {
            $(_self.miniCartModal.modalBoxContent).html(modalContent);
            if (addedAnother) {
                setTimeout(() => {
                    $('.js-first-icon').hide();
                    $('.js-minicart-delete-icon').show();
                }, 2000);
                addedAnother = false;
            } else {
                $('.js-first-icon').hide();
                $('.js-minicart-delete-icon').show();
            }
        } else {
            _self.miniCartModal = newModalFromString(
                modalContent,
                false,
                ['layer-minicart-modal', 'js-minicart'],
                function () {
                    setMiniCartOpen(true);
                },
                function () {
                    setMiniCartOpen(false);
                }
            );
            $(_self.miniCartModal.modalBox).addClass(
                'rightModalAttribute rightModalAttribute_sizeSmall js-minicart cc-minicart'
            );
            _self.miniCartModal.setContent(modalContent);
            _self.miniCartModal.open();

            $('body').trigger('minicart:open');
            setTimeout(() => {
                $('.js-first-icon').hide();
                $('.js-minicart-delete-icon').show();
            }, 2000);
        }
        $.spinner().stop();
        $('.js-cart-promotion-completed').closest('.cc-productWrapper').addClass('cc-productWrapper_completed');
        if ($('.cc-productPromo-textWrapper').hasClass('cc-dashboardPromo__item__label--loyal')) {
            $('.cc-dashboardPromo__item__label--loyal').parents('.cc-productWrapper_completed').addClass('cc-productWrapper_completed_loyal');
        } else if ($('.cc-productPromo-textWrapper').hasClass('cc-dashboardPromo__item__label--woman')) {
            $('.cc-dashboardPromo__item__label--woman').parents('.cc-productWrapper_completed').addClass('cc-productWrapper_completed_woman');
        } else if ($('.cc-productPromo-textWrapper').hasClass('cc-dashboardPromo__item__label--man')) {
            $('.cc-dashboardPromo__item__label--man').parents('.cc-productWrapper_completed').addClass('cc-productWrapper_completed_man');
        }
        spinStopped = true;

        $(_self.miniCartModal.modalBox)
            .find('.js-close-button')
            .on('click', function (e) {
                e.preventDefault();
                $('body').trigger('minicart:close');
                _self.miniCartModal.close();
            });

        $('#item-with-img').html($('#item-with-img-hidden').text());

        if ($('#personalize-page').length > 0) {
            // $('.popover').addClass('left-margin');
            $('.minicart.open').addClass('custom-right-fix');
        }

        // minicart bottom carousel section
        $(
            '.js-slotCarousel_recentlyView-carousel, .js-slotCarousel_suggestedProducts-carousel'
        ).slick({
            infinite: false,
            slidesToShow: 3.7,
            slidesToScroll: 1,
            arrows: false,
            centerMode: false,
            swipeToSlide: true,
            touchThreshold: 5,
            easing: 'ease-out',
            cssEase: 'ease-in-out'
        });
        $('body').trigger('listing:einsteinloadedSuggestedProducts', {
            container: '.js-slotCarousel_suggestedProducts-carousel',
            type: 'suggested_products',
        });

        bonusProductModalListener();
    };
    if (wait) {
        let orig = callback;
        callback = (evt) => {
            setTimeout(() => {
                orig(evt);
            }, 500);
        };
    }

    $.get(url, callback);

    if (Foundation.MediaQuery.atLeast('medium')) {
        window.scrollBy(0, -10);
    }
}

function forceShowWishlist (_self, pid) {
    let container = $('.js-mainHeader-minicart.pdp');
    if (container.length === 0 || Foundation.MediaQuery.atLeast('medium')) {
        container = $('.js-mainHeader-minicart');
    }

    container.addClass('open');

    var url = $('.js-wishlist').data('action-url') + '?pid=' + pid;

    if (container.find('.popover.show').length === 0) {
        $.spinner().start();
        $.get(url, function (data) {
            $.spinner().stop();
            container.find('.popover').empty().append(data).addClass('show');
            container.find('.overlay').addClass('hide');

            container
                .find('.popover')
                .find('.closeButton')
                .on('click touchstart', function (e) {
                    e.preventDefault();
                    hideMiniCart(_self, true);
                });
        });
    }
}

function addAnotherProductFromMiniCart (_self, url, form, $productContainer) {
    $.spinner().start();
    $.ajax({
        url: url,
        data: form,
        type: 'post',
        dataType: 'json',
        success: function (data) {
            $('.js-mainHeader-minicart').trigger('count:update', data);
            $('body').trigger('product:afterAddToCart', { ...data, form, $productContainer });
            $.spinner().stop();

            addedAnother = true;

            $('.card.error-message').remove();
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification(err.responseJSON.errorMessage);
            }
            $.spinner().stop();
        },
    });
}

function removeProductFromMiniCart (_self, params) {
    $.spinner().start();

    const url = appendToUrl(params.actionUrl, {
        pid: params.productID,
        uuid: params.uuid,
        uniqueIdentifier: params.uniqueIdentifier,
    });

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            $('.js-mainHeader-minicart').trigger('count:update', data);
            $.spinner().stop();

            forceShowMinicart(_self, true);
            $('.card.error-message').remove();
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification(err.responseJSON.errorMessage);
            }
            $.spinner().stop();
        },
    });
}

function locationIsCart () {
    return $('.page').data('action') === 'Cart-Show';
}

class Minicart {
    constructor () {
        this.miniCartModal = null;
    }

    run () {
        this.triggers();
        this.renderRicamo();
        // this.show();
        this.close();
        this.updateQuantity();
        this.productListeners();
        this.bonusProductListeners();
        this.applicablePromotion();

        setMiniCartOpen(false);
    }
    updateQuantity () {
        $('body').on('click', '.js-qty-button', function (e) {
            let $target = $(e.currentTarget);
            let $input = $target.siblings('.js-quick-quantity');
            let $minusInput = $target.siblings('.js-qty-minus');
            let quantity = parseInt($input.val());
            if ($target.hasClass('js-qty-plus')) {
                quantity++;
                $minusInput.attr('disabled', false);
            } else if ($target.hasClass('js-qty-minus')) {
                quantity = quantity > 1 ? quantity - 1 : 1;
                if (quantity === 1) {
                    $target.attr('disabled', true);
                }
            }
            $input.val(quantity);
            let selectedAllocation = $('.product-content-size input[type="radio"]:checked').data('allocation');
            const $plusButton = $('.js-complete-your-promo-quick-view').find('.js-qty-plus');
            const $addToCartButton = $('.js-complete-your-promo-quick-view').find('.add-to-cart-global');
            $plusButton.attr('disabled', selectedAllocation <= quantity);
            $addToCartButton.attr('disabled', selectedAllocation < quantity);
        });
    }
    applicablePromotion () {
        $('body').on('click', '.js-applicable-promotion', (e) => {
            e.preventDefault();
            let requestUrl = $(e.currentTarget).find('#complete-your-promo').data('url');
            const pid = $(e.currentTarget).find('.item-complete-your-promo').data('pid');
            const promotionId = $(e.currentTarget).find('#complete-your-promo').data('promotion-id');
            const isManPromo = $(e.currentTarget).find('#complete-your-promo').data('man-promo');
            const promoPrice = $(e.currentTarget).find('#complete-your-promo').data('promo-price');
            const promoPriceItemsTotal = $(e.currentTarget).find('#complete-your-promo').data('promo-price-items-total');
            const showResidualToTrigger = $(e.currentTarget).find('#complete-your-promo').data('is-residual');

            $.spinner().start();
            $.ajax({
                url: requestUrl,
                data: {
                    pid: pid,
                    promotionId: promotionId,
                    isManPromo: isManPromo,
                    promoPrice: promoPrice,
                    promoPriceItemsTotal: promoPriceItemsTotal,
                    showResidualToTrigger: showResidualToTrigger
                },
                method: 'GET',
                success: (data) => {
                    e.preventDefault();
                    var modalContent = data;
                    if (data.trim() === '') {
                        return;
                    }
                    var htmlContent = $('.cart-complete-promotion').html();
                    var modal = newModalFromString(
                        htmlContent,
                        false,
                        ['layer-complete-your-promo-modal'],
                        null,
                        null
                    );

                    $(modal.modalBox).addClass(
                        'new-footer-form-style rightModalAttribute rightModalAttribute_sizeLarge container-complete-your-promo-modal js-complete-your-promo'
                    );
                    modal.setContent(modalContent);
                    modal.open();
                    initSlotCarousel('.js-complete-your-promo');
                    $.spinner().stop();

                    $(modal.modalBox)
                        .find('.js-close-button')
                        .on('click', function (e) {
                            modal.close();
                        });

                    $(modal.modalBox)
                        .find('.js-back-button')
                        .on('click', function (e) {
                            modal.close();
                        });

                    $('body').on('product:afterAddToCart', function () {
                        modal.close();
                    });

                    if (document.querySelectorAll('.crosssell-view.js-cross-product').length > 4) {
                        $('.container-complete-your-promo-modal .show-more').removeClass('hidden');
                    }

                    $('.container-complete-your-promo-modal .show-more').on('click', (evt) => {
                        evt.preventDefault();
                        $('.crosssell-view.js-cross-product').removeClass('hide-for-medium');
                        $('.container-complete-your-promo-modal .show-more').addClass('hide');
                        $('body').trigger('product:crossSellLoaded', {loadHead: false});
                    });

                    $('body').trigger('product:crossSellLoaded', {loadHead: true});
                },
                error: () => {
                    $.spinner().stop();
                },
            });
        });
        $('body').on('click', '.js-cart-applicable-promotion', (e) => {
            e.preventDefault();
            let requestUrl = $(e.currentTarget).find('#complete-your-promo').data('url');
            const pid = $(e.currentTarget).find('.item-complete-your-promo').data('pid');
            const promotionId = $(e.currentTarget).find('#complete-your-promo').data('promotion-id');
            const poductsAdded = $(e.currentTarget).find('#complete-your-promo').data('poducts-added') || '';
            const triggeringAmount = $(e.currentTarget).find('#complete-your-promo').data('triggering-amount') || '';
            const minicartModal = $(e.currentTarget).closest('.js-minicart').length > 0 || false;
            const isLoyalPromo = $(e.currentTarget).find('#complete-your-promo').data('loyal-promo');
            const isManPromo = $(e.currentTarget).find('#complete-your-promo').data('man-promo');
            const promoPrice = $(e.currentTarget).find('#complete-your-promo').data('promo-price');
            const promoPriceItemsTotal = $(e.currentTarget).find('#complete-your-promo').data('promo-price-items-total');
            const showResidualToTrigger = $(e.currentTarget).find('#complete-your-promo').data('is-residual');

            $.spinner().start();
            $.ajax({
                url: requestUrl,
                data: {
                    pid: pid,
                    promotionId: promotionId,
                    cartApplicablePromo: true,
                    poductsAdded: poductsAdded,
                    triggeringAmount: triggeringAmount,
                    minicartModal: minicartModal,
                    showResidualToTrigger: showResidualToTrigger,
                    promoPrice: promoPrice,
                    promoPriceItemsTotal: promoPriceItemsTotal
                },
                method: 'GET',
                success: (data) => {
                    e.preventDefault();
                    var modalContent = data;
                    if (data.trim() === '') {
                        return;
                    }
                    var htmlContent = $('.cart-complete-promotion').html();
                    var modal = newModalFromString(
                        htmlContent,
                        false,
                        ['layer-complete-your-promo-modal', 'cc-low-z-index', 'js-complete-your-promo-modal', 'cc-cartPromotionModal'],
                        null,
                        () => {
                            modal.destroy();
                            if ($('.page').data('action') !== 'Product-Show' && $('.page').data('action') !== 'Search-Show') {
                                $.spinner().start();
                                location.reload();
                            }
                        }
                    );
                    if (isLoyalPromo) {
                        $(modal.modalBox).addClass('cc-dashboardPromo__item__label--loyal');
                    } else if (isManPromo) {
                        $(modal.modalBox).addClass('cc-dashboardPromo__item__label--man');
                    } else {
                        $(modal.modalBox).addClass('cc-dashboardPromo__item__label--woman');
                    }
                    $(modal.modalBox).addClass(
                        'new-footer-form-style rightModalAttribute rightModalAttribute_sizeLarge container-complete-your-promo-modal js-complete-your-promo'
                    );
                    modal.setContent(modalContent);
                    modal.open();
                    initSlotCarousel('.js-complete-your-promo');
                    $.spinner().stop();

                    $(modal.modalBox)
                        .find('.js-close-button')
                        .on('click', function (e) {
                            modal.close();
                        });

                    $(modal.modalBox)
                        .find('.js-back-button')
                        .on('click', function (e) {
                            modal.close();
                        });

                    $('body').on('product:afterAddToCart', function () {
                        //modal.close();
                    });

                    if (document.querySelectorAll('.crosssell-view.js-cross-product').length > 4) {
                        $('.container-complete-your-promo-modal .show-more').removeClass('hidden');
                    }

                    $('.container-complete-your-promo-modal .show-more').on('click', (evt) => {
                        evt.preventDefault();
                        $('.crosssell-view.js-cross-product').removeClass('hide-for-medium');
                        $('.container-complete-your-promo-modal .show-more').addClass('hide');
                        $('body').trigger('product:crossSellLoaded', {loadHead: false});
                    });

                    $('body').trigger('product:crossSellLoaded', {loadHead: true});
                },
                error: () => {
                    $.spinner().stop();
                },
            });
        });
        $('.js-cart-promotion-completed').closest('.cc-productWrapper').addClass('cc-productWrapper_completed');
        if ($('.cc-productPromo-textWrapper').hasClass('cc-dashboardPromo__item__label--loyal')) {
            $('.cc-dashboardPromo__item__label--loyal').parents('.cc-productWrapper_completed').addClass('cc-productWrapper_completed_loyal');
        }
        if ($('.cc-productPromo-textWrapper').hasClass('cc-dashboardPromo__item__label--woman')) {
            $('.cc-dashboardPromo__item__label--woman').parents('.cc-productWrapper_completed').addClass('cc-productWrapper_completed_woman');
        }
        if ($('.cc-productPromo-textWrapper').hasClass('cc-dashboardPromo__item__label--man')) {
            $('.cc-dashboardPromo__item__label--man').parents('.cc-productWrapper_completed').addClass('cc-productWrapper_completed_man');
        }
        $('body').on('click', '.js-add-promotion-item', e => {
            e.preventDefault();

            let clickedProductId = $(e.target).data('pid');
            $.spinner().start();
            // modal options
            var modalOptions = {
                footer: false,
                closeMethods: ['overlay', 'button', 'escape'],
                closeLabel: '<svg version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"> <path d="M12,11.3L22.3,1L23,1.7L12.7,12L23,22.3L22.3,23L12,12.7L1.7,23L1,22.3L11.3,12L1,1.7L1.7,1C1.7,1,12,11.3,12,11.3z"/></svg>',
                cssClass: ['quickview-modal', 'js-complete-your-promo-quick-view', 'cc-completePromotionModal'],
                onClose: () => {
                    if ($('.js-complete-your-promo-quick-view').length === 0) {
                        $('.carousel-inner, .slick-initialized:not(.suggested-products-slider)').slick('unslick');
                        modal.destroy();
                    }
                },
                beforeClose: () => {
                    if ($('.js-complete-your-promo-quick-view').length === 0) {
                        if ($('.tingle-modal.tingle-modal--visible').length < 2) {
                            $('html').removeClass('html-tingle-enabled');
                        }
                        return true;
                    }
                }
            };
            const modal = newModalWithOptions(modalOptions);
            this.currentlyOpenedModal = modal;

            $.ajax({
                url: $(e.currentTarget).attr('href'),
                method: 'GET',
                dataType: 'json',
                success: rsp => {
                    modal.setContent(rsp.renderedTemplate);
                    let valuesAllocations = rsp.product.variationAttributes[1].values;
                    // Move close button inside modal content box
                    //moveModalCloseButton();
                    $('.quickview-modal').addClass('quickview-modal--intimissimi').addClass('js-notifyMe-modal');
                    $(modal.modalBox).addClass('rightModalAttribute');
                    modal.open();
                    $('html').addClass('html-tingle-enabled');
                    // Slick carousel
                    $('.carousel-inner').slick({
                        dots: false,
                        arrows: false,
                        slidesToShow: 2.3,
                        infinite: false,
                        slidesToScroll: 1
                    });
                    productSlider();
                    $.spinner().stop();
                    $(modal.modalBox).on('click', '.close-custom', function () {
                        modal.close();
                        modal.destroy();
                    });
                    $('.js-complete-your-promo-quick-view').find('.label-wrapper').removeClass('hide');
                    $('.js-complete-your-promo-quick-view').on('mousedown', e => {
                        if ($(e.target).closest('.tingle-modal-box').length === 0) {
                            modal.close();
                            modal.destroy();
                        }
                    });
                    $(modal.modalBox).on('click', '.js-close-select-size', function () {
                        let modal = $('.js-modal-quick-size-quantity');
                        modal.addClass('hidden').removeClass('open');
                    });
                    valuesAllocations.forEach(function (element) {
                        $(this).closest('.product-content-size').find('input[type="radio"]').each(function () {
                            if ($(this).attr('id') === element.id && element.allocation <= 10) {
                                $(this).attr('data-allocation', element.allocation);
                            }
                        });
                    });
                    // Keep increase and add to cart buttons updated based on the allocation of the selected product
                    $(modal.modalBox).on('change', '.product-content-size input[type="radio"]', function (e) {
                        let selectedAllocation = parseInt($(e.currentTarget).data('allocation'));
                        let quantity = parseInt($('.js-quick-quantity').val());
                        const $plusButton = $(modal.modalBox).find('.js-qty-plus');
                        const $addToCartButton = $(modal.modalBox).find('.add-to-cart-global');

                        $plusButton.attr('disabled', selectedAllocation <= quantity);
                        $addToCartButton.attr('disabled', selectedAllocation < quantity);
                    });

                    $('body').off('updateQuickAddToCartModal');
                    $('body').on('updateQuickAddToCartModal', function (data, form) {
                        $('.layer-complete-your-promo-modal .cc-cartPromotionModal-footer-tracker_item:not(.cc-cartPromotionModal-footer-tracker_item_active)').first().addClass('cc-cartPromotionModal-footer-tracker_item_active');
                        let $productItem = $('.layer-complete-your-promo-modal').find('div[itemid="' + $(modal.modalBox).find('.add-to-cart-global').data('pid') + '"]').closest('.js-cross-product').first();
                        let quantity = parseInt(form.quantity);
                        if ($productItem.find('.js-added-text').hasClass('hidden')) {
                            $productItem.find('.js-added-text').removeClass('hidden').addClass('cc-cartPromotionModal-productCards-body-confirmation');
                            $productItem.find('.js-added-size').removeClass('hidden');
                            $productItem.find('.js-added-quantity').removeClass('hidden');
                            $productItem.find('.js-added-size-value').html($(modal.modalBox).find('.js-selected-size').html());
                            $productItem.find('.js-add-promotion-item').data('selected-size', $(modal.modalBox).find('.js-selected-size').html());
                            $productItem.addClass('cc-cartPromotionModal-productCards-product_active');
                            for (let i = 1; i < quantity; i++) {
                                let $productItemcopy = $productItem.clone();
                                $productItem.after($productItemcopy);
                                $('.js-cartPromotionModal-footer_active').next('.cc-cartPromotionModal-footer-tracker_item').addClass('cc-cartPromotionModal-footer-tracker_item_active js-cartPromotionModal-footer_active');
                            }
                            $('.js-cartPromotionModal-footer_active').next('.cc-cartPromotionModal-footer-tracker_item').addClass('cc-cartPromotionModal-footer-tracker_item_active js-cartPromotionModal-footer_active');
                        } else {
                            for (let i = 0; i < quantity; i++) {
                                let $productItemcopy = $productItem.clone();
                                $productItemcopy.find('.js-added-size-value').html($(modal.modalBox).find('.js-selected-size').html());
                                $productItem.after($productItemcopy);
                                $('.js-cartPromotionModal-footer_active').next('.cc-cartPromotionModal-footer-tracker_item').addClass('cc-cartPromotionModal-footer-tracker_item_active js-cartPromotionModal-footer_active');
                            }
                        }
                    });
                    if ($('.js-complete-your-promo-quick-view .add-to-cart-global').data('disabled') === true) {
                        $('.js-complete-your-promo-quick-view .add-to-cart-global').prop('disabled', true);
                    }
                    let $productItemAdd = $('.layer-complete-your-promo-modal').find('a[itemid="' + $(modal.modalBox).find('.add-to-cart-global').data('pid') + '"]').closest('.js-cross-product').first().find('.js-add-promotion-item');
                    if ($productItemAdd.data('selected-size') !== undefined) {
                        $(modal.modalBox).find('#' + $productItemAdd.data('selected-size')).trigger('click');
                    }
                },
                error: () => {
                    $.spinner().stop();
                }
            });
        });
        if ($('.page').data('action') === 'Search-Show') {
            $('body').on('click', '.js-wishlist-add-to-cart', function (e) {
                e.preventDefault();
                var pid;
                var addToCartUrl;
                var $target = $(e.currentTarget);
    
                $('body').trigger('product:beforeAddToCart', this);
    
                pid = $(this).data('pid');
                addToCartUrl = $(this).data('url');
                var promoId = $(this).data('promotion-id') || false;
                var $productContainer = $(this).closest('.wishlist-product-card');
    
                var form = {
                    pid: pid,
                    quantity: 1,
                    promoId: promoId
                };
    
                if ($(this).data('option')) {
                    form.options = JSON.stringify($(this).data('option'));
                }
                $.spinner().start();
    
                $(this).trigger('updateAddToCartFormData', form);
                if ($('.js-complete-your-promo').length > 0) {
                    $('.js-complete-the-promo-status').val($('.js-complete-the-promo-status').val() - form.quantity);
                    form.completePromoItems = $('.js-complete-the-promo-status').val();
                }
    
                if (addToCartUrl) {
                    $.ajax({
                        url: addToCartUrl,
                        method: 'POST',
                        data: form,
                        success: function (data) {
                            if (data.completePromoItemsLabel && data.completePromoItemsLabel !== '' && $('.js-completeYourPromo-header_remaining').length > 0) {
                                $('.js-completeYourPromo-header_remaining').html(data.completePromoItemsLabel);
                                if (form.completePromoItems === '0') {
                                    $('.js-completeYourPromo-header_remaining').addClass('cc-cartPromotionModal-footer_completed');
                                }
                                $('.js-cartPromotionModal-footer_active').next('.cc-cartPromotionModal-footer-tracker_item').addClass('cc-cartPromotionModal-footer-tracker_item_active js-cartPromotionModal-footer_active');
                            }
                            $('body').trigger('product:afterAddToCart', { ...data, form, $productContainer });
                            $('body').trigger('count:update', data);
    
                            if (data.error) {
                                return;
                            }
                            if ($('.add-to-cart-messages').length === 0) {
                                $('body').append('<div class="add-to-cart-messages"></div>');
                            }
                            if ($('.page[data-action="Cart-Show"]').length > 0) {
                                if (history.scrollRestoration) {
                                    history.scrollRestoration = 'manual';
                                }
                            }
                            if ($target.closest('.js-complete-your-promo').length > 0) {
                                $target.closest('.js-prodTile').find('.js-added-text').removeClass('hidden').addClass('cc-cartPromotionModal-productCards-body-confirmation');
                                $target.closest('.js-prodTile').parents('.cc-cartPromotionModal-productCards-product').addClass('cc-cartPromotionModal-productCards-product_active');
                                $target.closest('.js-prodTile').find('.cc-intProductDetail-colors-heading').hide();
                                $target.closest('.js-prodTile').find('.js-added-quantity').removeClass('hidden');
                                $target.parent().hide();
                                if ($target.closest('.js-wishlist-items-container').length > 0) {
                                    let $item = $target.closest('.js-cross-product').clone();
                                    if ($('.js-items-container .js-cross-product').length > 0) {
                                        $('.js-items-container .js-cross-product').first().before($item);
                                    } else {
                                        $('.js-items-container').append($item);
                                    }
                                    $target.closest('.js-cross-product').remove();
                                    if ($('.js-wishlist-items-container .js-cross-product').length === 0) {
                                        $('.js-wishlist-items-container').hide();
                                    }
                                }
                            } else {
                                location.reload();
                            }
                            $.spinner().stop();
                        },
                        error: function () {
                            $.spinner().stop();
                        }
                    });
                }
            });
        }
    }

    triggers () {
        var _self = this;
        $('.js-mainHeader-minicart').on('count:update', function (event, count) {
            const $counter = $('.js-mainHeader-minicart .js-mainHeader-counter_minicart');
            if (count && $.isNumeric(count.quantityTotal)) {
                if (count.quantityTotal > 0) {
                    $counter
                        .closest('.js-mainHeader-minicart')
                        .addClass('cc-mainHeader-minicart_full');
                } else {
                    $counter
                        .closest('.js-mainHeader-minicart')
                        .removeClass('cc-mainHeader-minicart_full');
                }

                $counter.text(count.quantityTotal).removeClass('hidden');
            }
        });

        $('body').on('product:afterAddToCart', function (e, data) {
            if (locationIsCart() && $('.js-complete-your-promo-modal').length === 0) {
                $.spinner().start();
                location.reload();
            }
            $('.js-mainHeader-minicart').trigger('count:update', data);

            // Supress minicart opening from cart buy again tab order again page
            if ($('.page').data('action') === 'OrderAgain-ShowCart') {
                return;
            }

            const bonusProductModal = QuickUpdate.methods.getBonusProductModal();
            if (bonusProductModal && bonusProductModal.modal) {
                bonusProductModal.close();
                bonusProductModal.destroy();
            }

            let product;
            if (data.form && data.form.pid) {
                product = data.form.pid;
            } else {
                const cart = data.cart;
                const items = cart.items;
                for (var i = 0; i < items.length; i++) {
                    if (items[i].UUID === data.pliUUID) {
                        product = items[i].id;
                        break;
                    }
                }
            }
            var promoId = data.form.promoId || false;

            if ($('.js-addToCart-tick').length) {
                forceShowMinicart(_self, true, product, promoId, true);
            } else {
                forceShowMinicart(_self, true, product, promoId);
            }
            if ($('.js-complete-your-promo-quick-view').length > 0) {
                // $('.js-complete-your-promo-quick-view .close-custom').trigger('click');
                $('.js-complete-your-promo-quick-view .product-quickview .close-custom').eq(0).trigger('click'); // TODO: temporary fix for breaking analytics!
            }
        });

        $('body').on('product:afterAddToCartGiftCard', function (e, data) {
            // Show Notification
            let product;
            if (data.form && data.form.pid) {
                product = data.form.pid;
            } else {
                const cart = data.cart;
                const items = cart.items;
                for (var i = 0; i < items.length; i++) {
                    if (items[i].UUID === data.pliUUID) {
                        product = items[i].id;
                        break;
                    }
                }
            }
            forceShowMinicart(_self, true, product);
        });
        /*
        $('body').on('product:afterAddToWishlist', function (e, data) {
            // Show Notification
            let product;
            if (data.pid) {
                product = data.pid;
            }
            forceShowWishlist(_self, true, product);
        });
        */
    }

    renderRicamo () {
        var totalCount = parseInt($('#totalCount').text());
        for (var i = 0; i < totalCount; i++) {
            $('#count-' + (i + 1)).html($('.hidden-' + (i + 1)).text());
        }
    }

    show () {
        var _self = this;
        $('.minicart').on('mouseenter focusin', function () {
            // Clear any existing timers
            clearTimeout(timer);

            // Start a new timer to delay the opening
            timer = setTimeout(function () {
                if (!isMiniCartOpen()) {
                    forceShowMinicart(_self, true);
                }
            }, 1300);
        });
    }

    close () {
        var _self = this;
        $('body').on('click', '.minicart-close', (e) => {
            hideMiniCart(_self);
        });
    }

    productListeners () {
        const _self = this;
        $('body').on('click', '.js-minicart .js-add-another-to-cart', (e) => {
            e.preventDefault();
            const $productContainer = $(e.currentTarget).closest('.cc-minicart-productWrapper').find('.analytics.checkout');
            $productContainer.addClass('product-info');
            const analytics = $($productContainer).data();

            const action = $(e.currentTarget).data('action');
            const data = {
                pid: $(e.currentTarget).data('pid'),
                quantity: 1,
                pidsObj: {},
                childProducts: [],
                GTMItemListName: analytics.item_list_name,
                GTMItemListId: analytics.item_list_id,
                GTMIndex: analytics.index
            };
            // Add another personalized product
            if ($(e.currentTarget).data('uniqueidentifier')) {
                data.uniqueIdentifierPers = $(e.currentTarget).data('uniqueidentifier');
                data.uniqueIdentifierNew = Math.random();
            }
            addAnotherProductFromMiniCart(_self, action, data, $productContainer);
        });

        $('body').on('click', '.js-minicart .remove-product', (e) => {
            e.preventDefault();

            // product info
            const data = {
                actionUrl: $(e.currentTarget).data('action'),
                productID: $(e.currentTarget).data('pid'),
                uuid: $(e.currentTarget).data('uuid'),
            };

            removeProductFromMiniCart(_self, data);
            let outDiv = $(e.currentTarget).closest('.product-line-item').find(' .analytics.checkout');
            $('body').trigger('removeItemFromCartSuccessful', { data, productData: outDiv.data(), remove_type: 'minicart' });
        });

        $('body').on('click', '.quick-buy-sizes-item', function (e) {
            // TODO - check how to remove this and include quickViewHelper
            if ($('.page').data('action') === 'Search-Show') {
                return;
            }
            e.preventDefault();
            if ($(this).hasClass('disable') || !$(this).data('variant')) {
                return false;
            }

            var url = $(this).data('variant');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                success: function (response) {
                    $.spinner().stop();
                    const $productContainer = $(e.target);

                    // For minicart promo carousel
                    var promotionId =
                        $productContainer
                            .closest('.container-complete-your-promo-modal')
                            .find('.modal-header')
                            .data('promoId') || false;

                    if (response.product.available && !response.product.comingSoon) {
                        addToCartFromListing(response.product.id, promotionId, $productContainer);
                    } else {
                        $('body').trigger('product:afterAddToCartFailed', {
                            ...response,
                            $productContainer,
                        });
                    }
                },
                error: function (err) {
                    console.error('ErrorCase: ' + err.message);
                    $.spinner().stop();
                },
            });
        });
    }

    bonusProductListeners () {
        var _self = this;
        $('body').on('click', '.js-minicart .bonus-product-remove-btn', (e) => {
            var bonusProductIdRemoveAction = $(e.currentTarget).data('action');

            $.spinner().start();
            $.ajax({
                url: bonusProductIdRemoveAction,
                method: 'GET',
                dataType: 'json',
                success: (data) => {
                    $('.js-mainHeader-minicart').trigger('count:update', data);
                    $.spinner().stop();
                    forceShowMinicart(_self, true);
                },
                error: (err) => {
                    console.error('ErrorCase: ' + err.message);
                    $.spinner().stop();
                },
            });
        });

        $('body').on('click', '.js-minicart .wrapper-bonus-product-button, .js-edit-bonus-product', function (e) {
            e.preventDefault();
            $.spinner().start();
            var url;
            if ($(this).hasClass('wrapper-bonus-product-button')) {
                url = $(this).find('.bonus-product-button').data('url');
            } else {
                url = $(this).data('url');
            }
            var preselectedSize = $(e.currentTarget).closest('.js-productWrapper_bonus').find('.js-checkout-product').length > 0 ? $(e.currentTarget).closest('.js-productWrapper_bonus').find('.js-checkout-product').data('size') : '';
            $.ajax({
                url: url,
                method: 'GET',
                dataType: 'json',
                success: function (data) {
                    if (data.noedit) {
                        $('.js-mainHeader-minicart').trigger('count:update', data);
                        $.spinner().stop();

                        forceShowMinicart(_self, true);
                    } else {
                        data.preselectedSize = preselectedSize;
                        QuickUpdate.methods.chooseBonusProducts(data);
                    }
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    }
}

let minicart = new Minicart();
export default minicart;
